'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import RoundedButton from 'layout-dnd-components/DndToolbar/RoundedButton';
import { DEFAULT_RESPONSIVE_SIZE } from 'layout-dnd-components/DndToolbar/constants';
import { openAddSectionPanel, openPatagoniaInpageSectionsPanel } from 'ContentEditorUI/redux/actions/inpageActions';
import { OFFSCREEN_POSITION } from 'InpageEditorUI/lib/layoutSection/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const mapDispatchToProps = {
  openAddSectionPanel,
  openPatagoniaInpageSectionsPanel
};
class ResponsiveInsertNewSectionHandle extends Component {
  render() {
    const {
      top,
      left,
      onHandleMouseDown,
      responsiveSize,
      highlightTop,
      highlightLeft,
      highlightWidth
    } = this.props;
    return /*#__PURE__*/_jsx(RoundedButton, {
      iconName: "add",
      top: top,
      left: left,
      highlightTop: highlightTop,
      highlightLeft: highlightLeft,
      highlightWidth: highlightWidth,
      useHighlightLine: true,
      responsiveSize: responsiveSize,
      testId: "insert-new-section-button"
      // Trying out with no labels for now
      //label={I18n.text('inpage.actionToolbar.insertSection.label')}
      ,
      onClick: this.props.openPatagoniaInpageSectionsPanel,
      onMouseDown: onHandleMouseDown
    });
  }
}
ResponsiveInsertNewSectionHandle.propTypes = {
  top: PropTypes.number,
  left: PropTypes.number,
  highlightTop: PropTypes.number,
  highlightLeft: PropTypes.number,
  highlightWidth: PropTypes.number,
  onHandleMouseDown: PropTypes.func,
  responsiveSize: PropTypes.string,
  openAddSectionPanel: PropTypes.func,
  openPatagoniaInpageSectionsPanel: PropTypes.func
};
ResponsiveInsertNewSectionHandle.defaultProps = {
  responsiveSize: DEFAULT_RESPONSIVE_SIZE,
  top: OFFSCREEN_POSITION.TOP,
  left: OFFSCREEN_POSITION.LEFT
};
export default connect(undefined, mapDispatchToProps)(ResponsiveInsertNewSectionHandle);